import { ProviderToken } from '@angular/core';
import { AbstractDataProvider } from '@epicuro-next/data-providers/base-data-provider';

import {
  COMMERCIAL_LIST_PROVIDER_KEY,
  COMMERCIAL_LIST_PROVIDER_TOKEN,
  CONFIGURATIONS_PROVIDER_KEY,
  CONFIGURATIONS_PROVIDER_TOKEN,
  DYNAMIC_DATA_PROVIDER_KEY,
  DYNAMIC_DATA_PROVIDER_TOKEN,
  GLOBAL_STORE_PROVIDER_KEY,
  GLOBAL_STORE_PROVIDER_TOKEN,
  HTTP_BODY_PROVIDER_KEY,
  HTTP_BODY_PROVIDER_TOKEN,
  HTTP_ORDER_FILTERS_KEY,
  HTTP_ORDER_FILTERS_TOKEN,
  HTTP_ORDER_KEY,
  HTTP_ORDER_TOKEN,
  HTTP_PROVIDER_KEY,
  HTTP_PROVIDER_TOKEN,
  LIST_ACCESS_PROVIDER_KEY,
  LIST_ACCESS_PROVIDER_TOKEN,
  LIST_WITH_PRODUCT_SEARCH_PROVIDER_KEY,
  LIST_WITH_PRODUCT_SEARCH_PROVIDER_TOKEN,
  OPENED_LIST_DATA_PROVIDER_KEY,
  OPENED_LIST_DATA_PROVIDER_TOKEN,
  OPENED_LIST_ENTITY_PROVIDER_KEY,
  OPENED_LIST_ENTITY_PROVIDER_TOKEN,
  PRODUCT_BASKET_PROVIDER_KEY,
  PRODUCT_BASKET_PROVIDER_TOKEN,
  PRODUCT_FILTERS_PROVIDER_KEY,
  PRODUCT_FILTERS_PROVIDER_TOKEN,
  PRODUCT_PROVIDER_KEY,
  PRODUCT_PROVIDER_TOKEN,
  UTILITIES_PROVIDER_KEY,
  UTILITIES_PROVIDER_TOKEN,
} from './tokens';

export const DATA_PROVIDERS_TOKENS_MAP = new Map<
  string,
  ProviderToken<AbstractDataProvider>
>([
  [COMMERCIAL_LIST_PROVIDER_KEY, COMMERCIAL_LIST_PROVIDER_TOKEN],
  [CONFIGURATIONS_PROVIDER_KEY, CONFIGURATIONS_PROVIDER_TOKEN],
  [DYNAMIC_DATA_PROVIDER_KEY, DYNAMIC_DATA_PROVIDER_TOKEN],
  [GLOBAL_STORE_PROVIDER_KEY, GLOBAL_STORE_PROVIDER_TOKEN],
  [HTTP_BODY_PROVIDER_KEY, HTTP_BODY_PROVIDER_TOKEN],
  [HTTP_ORDER_FILTERS_KEY, HTTP_ORDER_FILTERS_TOKEN],
  [HTTP_ORDER_KEY, HTTP_ORDER_TOKEN],
  [HTTP_PROVIDER_KEY, HTTP_PROVIDER_TOKEN],
  [LIST_ACCESS_PROVIDER_KEY, LIST_ACCESS_PROVIDER_TOKEN],
  [
    LIST_WITH_PRODUCT_SEARCH_PROVIDER_KEY,
    LIST_WITH_PRODUCT_SEARCH_PROVIDER_TOKEN,
  ],
  [OPENED_LIST_DATA_PROVIDER_KEY, OPENED_LIST_DATA_PROVIDER_TOKEN],
  [OPENED_LIST_ENTITY_PROVIDER_KEY, OPENED_LIST_ENTITY_PROVIDER_TOKEN],
  [PRODUCT_BASKET_PROVIDER_KEY, PRODUCT_BASKET_PROVIDER_TOKEN],
  [PRODUCT_FILTERS_PROVIDER_KEY, PRODUCT_FILTERS_PROVIDER_TOKEN],
  [PRODUCT_PROVIDER_KEY, PRODUCT_PROVIDER_TOKEN],
  [UTILITIES_PROVIDER_KEY, UTILITIES_PROVIDER_TOKEN],
]);
